import IncreaseYourAdvanceLimits from 'features/advance/screens/registration/IncreaseYourAdvanceLimits/IncreaseYourAdvanceLimits';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function IncreaseYourAdvanceLimitsPage() {
  return (
    <PinwheelContextProvider>
      <IncreaseYourAdvanceLimits />
    </PinwheelContextProvider>
  );
}
